import { generateHTML } from '@tiptap/core'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import ListItem from '@tiptap/extension-list-item'
import BulletList from '@tiptap/extension-bullet-list'

function convertJSON(str) {
  let json = JSON.parse(str);
    str = generateHTML(json,[
        Document,
        Paragraph,
        Text,
        ListItem,
        BulletList
    ])
    return str;
}


export{convertJSON}